module.exports = __webpack_public_path__ + "img/icon_uestion.854f71e9.svg";